import Button from 'tailwind-components/Button/Button';
import CollapsibleSection from 'components/CollapsibleList/CollapsibleSection';
import React from 'react';
import propTypes from 'prop-types';
import style from './mainSectionCarriers.module.scss';

export default function ICHRASection({ expandedState, setExpandedState }) {
  return (
    <CollapsibleSection
      title='ICHRA'
      id='ICHRA'
      subtitle='Group Offering on the Individual Market'
      arrowRight
      expanded={expandedState.ichra}
      onClick={() =>
        setExpandedState({
          ...expandedState,
          ichra: !expandedState.ichra
        })
      }
    >
      <div className={style.myAppointmentsSection}>
        <div className={style.children}>
          <a
            target='_blank'
            rel='noreferrer noopener'
            href='https://forms.zohopublic.com/oneillmarketing/form/ONeillMarketingICHRAForm/formperma/8QW1aZ_iTmQP3BN_go1pZbJWRFPy16NEQiIzqtTXfvE'
          >
            <Button
              text='Click here to request a census and additional information'
              variant='primaryLight'
            />
          </a>
        </div>
      </div>
    </CollapsibleSection>
  );
}

ICHRASection.propTypes = {
  expandedState: propTypes.object.isRequired,
  setExpandedState: propTypes.func.isRequired
};
